module.exports = __webpack_public_path__ + "img/C06TechPharmacology_ua.06efc670.webp";